import { render, staticRenderFns } from "./SearchCustomer.vue?vue&type=template&id=c689ab32&scoped=true"
import script from "./SearchCustomer.vue?vue&type=script&lang=js"
export * from "./SearchCustomer.vue?vue&type=script&lang=js"
import style0 from "./SearchCustomer.vue?vue&type=style&index=0&id=c689ab32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c689ab32",
  null
  
)

export default component.exports